export const TimeoutMessage = /timeout of \d+ms exceeded/;
